import React from 'react'
import './css/HomeHero.css'
import Navbar from './Navbar'
import Logo from './../assets/icons/Logo.png'
import Cuisine from './../assets/images/CuisineHome.png'
import { Link } from 'react-router-dom'

function HomeHero() {
  return (
    <div className='HomeHero'>
        <div className='overlay'></div>
        <Navbar className='navbar'/>
        <div className='content'>
            <div className='left'>
              <p className='welcome'>Welcome to</p>
              <img className='logo' src={Logo} alt='Logo' />
              <Link to="/contact"><button className='cta'>Contact Us</button></Link>
            </div>
            <div className='right'>
              <img className='plate' src={Cuisine} alt="Plate" />
            </div>
        </div>
    </div>
  )
}

export default HomeHero